import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CreateOpportunities from './Apps/CreateOpportunities';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack';
import RecruitmentHelperEmailAutomation from './Apps/RecruitmentHelperEmailAutomation';
import FeedbackModal from './Apps/Feedback';
import { createTheme, ThemeProvider } from '@mui/material';
import colors from './styles/colors';

const theme = createTheme({
  typography: {
    color: colors.black,

    h4: {
      fontFamily: 'Alata',
    },
    body1: {
      fontSize: '18px',
      fontFamily: 'Quattrocento Sans',
    },
    body2: {
      fontSize: '16px',
      fontFamily: 'Quattrocento Sans',
    },
    caption: {
      fontSize: '14px',
      fontFamily: 'Quattrocento Sans',
    }
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div style={{ paddingBottom: '20px' }}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3}>
          <RecruitmentHelperEmailAutomation />
        </SnackbarProvider>
      </ThemeProvider>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
